import React, { useState, useEffect } from "react"
import { motion } from 'framer-motion'
import API from "../../Common/API"
import HomePageLoader from "../../Components/Loaders/HomePageLoader"
import { LuIndianRupee } from "react-icons/lu";
import { BsBookmarkHeart, BsBookmarkHeartFill } from "react-icons/bs";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import emptyWish from '../../Assets/Images/Bookmarks-pana.svg'


const WishList = () => {

    const [loading, setLoading] = useState(true)
    const [productList, setProductList] = useState([])
    const isLoggedIn = useSelector((state) => state.auth.isLoggedIn)
    const history = useHistory()
    const userDetails = useSelector((state) => state.auth.userDetails)
    const [count, setCount] = useState(0)

    useEffect(() => {
        try {
            API.get('/products/getWishList').then((wishRes) => {
                if (wishRes.status === 200) {
                    setProductList(wishRes.data.data)
                    setLoading(false)
                }
            })
        } catch (err) {
            console.log(err)
        }
    }, [count])

    const viewProduct = (value) => {
        if (isLoggedIn) {
            history.push(`/product/${value._id}/view`, { wishList: true })
            localStorage.setItem('fromWishList', true)
        } else {
            history.push('/auth/login')
        }
    }

    const wishList = (value) => {
        let apiValues = {
            addedBy: userDetails.subject._id,
            productId: value._id
        }
        API.post('/products/wishList', apiValues).then((wishRes) => {
            if (wishRes.status === 200) {
                setCount(count + 1)
            }
        })
    }

    return (
        <motion.div className="relative h-full w-full px-2 md:px-20 flex flex-row justify-center">
            {
                loading ? <HomePageLoader /> : productList && productList.length > 0 ? <motion.div className="grid grid-cols-1 sm:grid-cols-1 gap-10 md:grid-cols-1 xl:grid-cols-4 lg:grid-cols-4">
                    {
                        productList && productList.length > 0 && productList.map((pro, i) => {
                            return <motion.div key={i} className="relative h-80 w-80 md:w-72 flex flex-col bg-white cursor-pointer drop-shadow-lg">
                                <motion.div className="absolute top-5 right-5 text-xl" onClick={() => wishList(pro.productId)}>{pro.activeStat === 'A' ? <BsBookmarkHeartFill /> : <BsBookmarkHeart />}</motion.div>
                                <motion.div className="px-2 py-2 h-60 flex flex-row justify-center" onClick={() => viewProduct(pro.productId)}>
                                    <img src={pro.product.images[0].imageUrl} width={400} alt="preview" />
                                </motion.div>
                                <motion.div className="px-2 my-1 flex-row flex items-center font-bold text-xl" onClick={() => viewProduct(pro.productId)}>
                                    <LuIndianRupee />{pro.productId.price}
                                </motion.div>
                                <motion.div className="px-2 my-1 flex flex-row text-primeColor/40" onClick={() => viewProduct(pro.productId)}>
                                    {pro.productId.productName}
                                </motion.div>
                            </motion.div>
                        })
                    }
                </motion.div> : <motion.div className="w-full h-full flex flex-col items-center justify-center">
                    <img src={emptyWish} width={500} height={500} />
                    <motion.div className="text-[#002557] font-bold text-xl">No products in wishlist</motion.div>
                </motion.div>
            }
        </motion.div>
    )
}

export default WishList